import { Button } from "react-migration/components/DeprecatedButton";
import { CircleSpec } from "./AnnotationSpec/CircleSpec";
import { Icon } from "react-migration/components/Icon";
import { MultiSelectSpec } from "./AnnotationSpec/MultiSelectSpec";
import { PointSpec } from "./AnnotationSpec/PointSpec";
import { PolygonSpec } from "./AnnotationSpec/PolygonSpec";
import { RectangleSpec } from "./AnnotationSpec/RectangleSpec";
import { RulerSpec } from "./AnnotationSpec/LineSpec";
import { TextBoxSpec } from "./AnnotationSpec/TextBoxSpec";
import { deleteDrawing } from "src/js/stores/drawing/actions/deleteDrawing";
import { deleteDrawingBulk } from "src/js/stores/drawing/actions/deleteDrawingBulk";
import { duplicateGeometry } from "src/js/stores/drawing/actions/duplicateGeometry";
import { getEditableDrawing } from "src/js/stores/drawing/actions/getEditableDrawing";
import { getMultiSelected } from "src/js/stores/drawing/actions/getMultiSelected";
import { getSelectedGeometry } from "src/js/stores/drawing/actions/getSelectedGeometry";
import { mapStore } from "src/js/stores/map/store";
import { setMultiSelected } from "src/js/stores/drawing/actions/setMultiSelected";
import { setSelectedGeometry } from "src/js/stores/drawing/actions/setSelectedGeometry";
import { useSnapshot } from "valtio/react";

export function DrawingsSelectionView() {
  const {
    settings: { zoom },
  } = useSnapshot(mapStore);
  const selectedDrawing = getSelectedGeometry();
  const editableDrawing = getEditableDrawing();
  const multiSelection = getMultiSelected();

  const drawing = selectedDrawing || editableDrawing;
  const shape = drawing?.properties.shape;
  const shouldRenderSingleSelection = drawing && !multiSelection;

  const onConfirmDelete = () => {
    if (multiSelection) {
      deleteDrawingBulk(multiSelection);

      setMultiSelected(null);
      return;
    }

    if (selectedDrawing) {
      deleteDrawing(selectedDrawing.id);
      setSelectedGeometry("");
    }
  };

  const duplicate = () => {
    selectedDrawing && duplicateGeometry(selectedDrawing.id, zoom);
  };

  if (!drawing && !multiSelection) return null;

  return (
    <>
      {shouldRenderSingleSelection && (
        <div className="bg-white p-2 flex flex-col gap-5">
          <div className="flex justify-between items-center">
            <h1 className="text-base font-extralight text-text-base-secondary">Details</h1>
            <div className="flex justify-between gap-2">
              {editableDrawing ? (
                <Button.Primary className="h-8" onClick={() => setSelectedGeometry(drawing.id)}>
                  Done
                </Button.Primary>
              ) : (
                <Button.Secondary title="Duplicate" size="small" className="w-8 h-8" onClick={duplicate}>
                  <Icon icon="icon-lt-copy-duplicate-line" size="sm" cursor="pointer" />
                </Button.Secondary>
              )}
              <Button.Secondary title="Delete" size="small" className="w-8 h-8" onClick={onConfirmDelete}>
                <Icon icon="icon-lt-delete-bin-line" size="sm" cursor="pointer" />
              </Button.Secondary>
            </div>
          </div>
          {shape === "Circle" && <CircleSpec drawing={drawing!} />}
          {shape === "Polygon" && <PolygonSpec drawing={drawing!} />}
          {(shape === "Ruler" || shape === "Polyline") && <RulerSpec drawing={drawing!} />}
          {shape === "Rectangle" && <RectangleSpec drawing={drawing!} />}
          {shape === "TextBox" && <TextBoxSpec drawing={drawing!} />}
          {shape === "Point" && <PointSpec drawing={drawing!} />}
        </div>
      )}
      {!shouldRenderSingleSelection && (
        <div className="bg-white p-2 flex-col gap-3">
          <div className="flex justify-between">
            <h1 className="text-base font-extralight text-text-base-secondary">Details</h1>
            <Button.Secondary title="Delete" size="small" className="min-w-12 h-8" onClick={onConfirmDelete}>
              <div className="mr-1">Delete all</div>
              <Icon icon="icon-lt-delete-bin-line" size="sm" cursor="pointer" />
            </Button.Secondary>
          </div>
          <MultiSelectSpec multiSelection={multiSelection} />
        </div>
      )}
    </>
  );
}
